export const InstallationTypeSectionIds = {
    Elevation: 'elevation-installation-config',
    Channel: 'channel-installation-config',
    Pipe: 'pipe-installation-config',
    Flume: 'flume-installation-config',
    Weir: 'weir-installation-config',
}

export enum ElevationInstallationFieldIds {
    ReferencePoint = 'elevation-reference-point',
    Datum = 'elevation-height',
    PhysicalOffset = 'elevation-physical-offset',
}

export enum ChannelInstallationFieldIds {
    Range = 'channel-range',
}

export const INSTALLATION_DEFAULT_CONSTANTS = {
    installationDesc1: '',
    installationDesc2: '',
    installationDesc3: '',
    installationDesc4: '',
    installationDesc5: '',
    wasCreatedFromImport: false,
}